export class NewFileFolder {
    id: number = 0;
    name: string;
    parentFolderId: number = 0;
    childFiles: any[] = [];
    isFolderReplacable: boolean = false;
    fileOtherInfoJsonList: FileInfo[] = [];
}

export interface FileInfo {
    name: string;
    replacedName: string;
    extension: string;
    size: string;
    isFileReplacable: boolean;
    fileExist: boolean;
    fileWarningCheck: boolean;
}

export class WarningFileFolder {
    folderName: string;
    parentFolderId: number = 0;
    fileInfos: FileInfo[] = [];
}

export interface IWarningFileFolderResponse {
    name: string;
    extension: string;
    isFolder: boolean;
}